import { Component, computed, Input} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Address } from '../../data/address';

type AddressFormModel = {
    streetAddress: FormControl<string>;
    city: FormControl<string>;  
    state: FormControl<string>;
    postcode: FormControl<string>;
    country: FormControl<string>;
  } 
type AddressFormModelMultiline = AddressFormModel & {
    streetAddress2: FormControl<string>;
    suburb: FormControl<string>;
};
@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss']
})
export class AddressComponent {

  @Input() isRequired: boolean = false;
  @Input() isSubmitted: boolean = false;
  @Input() label: string = 'Current Residential Address';
  /**
   * If the formGroup contains streetAddress2,
   * we display "Address Line 1" and "Address Line 2"
   * Otherwise we just display "Street Address"
   * 
   * Suburb is also optional
   * happily, business and applicant use different address structures :)
   */
  @Input() addressForm!: FormGroup<AddressFormModel> | FormGroup<AddressFormModelMultiline>;

  // I am not super stoked about this approach, but it worked
  get streetAddress2Control(): FormControl<string> | undefined {
    return (this.addressForm.controls as AddressFormModelMultiline).streetAddress2;
  }

  get suburbControl(): FormControl<string> | undefined {
    return (this.addressForm.controls as AddressFormModelMultiline).suburb;
  }

}
